export const MERCHANT_CODE__SET = merchantCode => ({
    type: 'MERCHANT_CODE__SET',
    payload: { merchantCode },
})
